<template>
  <div class="table-responsive mx-2">
    <LoadingSpinner 
      v-if="loading && items.length === 0" 
      :message="$t('subjects.loading')" 
      class="py-5" 
    />

    <template v-else>
      <!-- Mobile View -->
      <div class="d-block d-md-none">
        <div v-if="!loading && items.length === 0" class="text-center py-4 text-muted">
          <i class="fas fa-book fa-2x mb-2"></i>
          <p>{{ $t('subjects.noData') }}</p>
        </div>

        <div v-for="item in items" :key="'mobile-'+item.subject_id" class="card mb-3">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6 class="mb-1">{{ item.subject?.name || 'N/A' }}</h6>
                <p class="text-sm text-muted mb-1">{{ $t('subjects.code') }}: {{ item.subject?.code || 'N/A' }}</p>
              </div>
              <span class="badge badge-sm" :class="item.status === 'active' ? 'bg-success' : 'bg-secondary'">
                {{ item.status === 'active' ? $t('subjects.active') : $t('subjects.inactive') }}
              </span>
            </div>
            <div class="d-flex justify-content-end mt-2">
              <router-link
                :to="`/classes/${classId}/subjects/${item.subject_id}/edit`"
                class="btn btn-link text-info p-0 mx-1"
                :title="$t('subjects.edit')"
                  v-can="'class_subjects.update'"
              >
                <i class="fas fa-edit fa-sm"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- Desktop View -->
      <table class="table align-items-center mb-0 d-none d-md-table">
        <thead>
          <tr>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7">{{ $t('subjects.name') }}</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">{{ $t('subjects.code') }}</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">{{ $t('subjects.status') }}</th>
            <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center">{{ $t('subjects.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!loading && items.length === 0">
            <td colspan="4" class="text-center py-4 text-muted">
              <i class="fas fa-book fa-2x mb-2"></i>
              <p>{{ $t('subjects.noData') }}</p>
            </td>
          </tr>
          
          <template v-if="!loading">
            <tr v-for="item in items" :key="item.subject_id">
              <td>
                <div class="d-flex px-3 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ item.subject?.name || 'N/A' }}</h6>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center">
                <span class="text-xs font-weight-bold">{{ item.subject?.code || 'N/A' }}</span>
              </td>
              <td class="align-middle text-center">
                <span class="badge badge-sm" :class="item.status === 'active' ? 'bg-success' : 'bg-secondary'">
                  {{ item.status === 'active' ? $t('subjects.active') : $t('subjects.inactive') }}
                </span>
              </td>
              <td class="align-middle  pe-4 text-center">
                <div class="d-inline-flex">
                
                  <router-link
                    :to="`/classes/${classId}/subjects/${item.subject_id}/edit`"
                    class="btn btn-link text-info p-1 mx-1"
                    :title="$t('subjects.edit')"
                      v-can="'class_subjects.update'"
                  >
                    <i class="fas fa-edit fa-sm"></i>
                  </router-link>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </template>
  </div>
</template>

<script setup>
import { defineProps } from 'vue';
import LoadingSpinner from '@/components/common/LoadingSpinner.vue';

defineProps({
  items: {
    type: Array,
    required: true,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  },
  classId: {
    type: [String, Number],
    required: true
  }
});
</script>
